import Home from "@views/Home.vue";
import Configurator from "@views/Configurator.vue";

export default [
    { path: '/', component: Home, name: 'home' },
    { path: '/configurator/:productId', component: Configurator, name: 'configurator' },
]